import { getEnvironmentConfigs } from '../../environmentConfigs';
import { initialize as initializeRollbar } from './rollbar';

export async function initialize() {
  try {
    const { env } = await getEnvironmentConfigs();
    if (env === 'prod') {
      initializeRollbar();
    }
  } catch (e) {
    // biome-ignore lint/suspicious/noConsole: logging error in console
    console.error('Failed on initializing analytics tools:', e);
    return;
  }
}
